module.exports = __webpack_public_path__ + "static/media/level-eight.94a1513c.svg";